import React, { useEffect } from 'react';
import { v4 } from 'uuid';

import { userApiRequests } from './api-requests/user.tsx';

interface ErrorProps {
    error: Error;
}

export const errorFallback = ({ error }: ErrorProps) => {
    if (window.location.hostname === 'localhost') {
        return null;
    }

    const errorId = v4();

    useEffect(() => {
        (async () => {
            try {
                await userApiRequests.logException(error, errorId);
            } catch (logError) {
                // eslint-disable-next-line no-console
                console.error('Błąd przy logowaniu:', logError);
            }
        })();
    }, [error]);

    return (
        <div role="alert" style={{ padding: '1rem', backgroundColor: '#fdd', color: '#900' }}>
            <p>Coś poszło nie tak, uprzejmie prosimy o zgłoszenie do administracji.</p>
            <pre>Identyfikator błędu: {errorId}</pre>
        </div>
    );
};
